"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ReserveOnlineText_1 = require("./ReserveOnlineText");
var paymentApi_1 = require("../../../common/api/paymentApi");
var TransactionErrorTypes_1 = require("../../../common/enum/TransactionErrorTypes");
var useAppContext_1 = require("../../../common/react/useAppContext");
var Routes_1 = require("../../../common/enum/Routes");
var react_router_1 = require("react-router");
var ConfirmationMainContent_1 = require("../confirmationMainContent/ConfirmationMainContent");
var errorMessageHoc_1 = require("../../../common/components/presentation/Error/errorMessageHoc");
var MinimalLoader_1 = require("../../../common/components/presentation/MinimalLoader/MinimalLoader");
var queryString = require("query-string");
var ConfirmationReserveOnlineApexx = function (_a) {
    var componentHandleError = _a.componentHandleError;
    var history = react_router_1.useHistory();
    var _b = useAppContext_1.default(), setDeal = _b.setDeal, setCarConfiguration = _b.setCarConfiguration, setTransactionError = _b.setTransactionError;
    var _c = react_1.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var transactionTokenParam = queryString.parse(location.search).transactionToken;
    var transactionToken = transactionTokenParam
        ? typeof transactionTokenParam === 'string'
            ? transactionTokenParam
            : transactionTokenParam[0]
        : null;
    var verifyAccessCode = react_1.useCallback(function (transactionToken) { return __awaiter(void 0, void 0, void 0, function () {
        var resp, _a, deal, fullProductConfiguration, error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, paymentApi_1.default.verifyAccessCode({ transactionToken: transactionToken })];
                case 1:
                    resp = _d.sent();
                    if ((_b = resp.data) === null || _b === void 0 ? void 0 : _b.deal) {
                        _a = resp.data, deal = _a.deal, fullProductConfiguration = _a.deal.fullProductConfiguration;
                        setDeal(deal);
                        if (fullProductConfiguration) {
                            setCarConfiguration(fullProductConfiguration);
                        }
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _d.sent();
                    if ((_c = error_1.response) === null || _c === void 0 ? void 0 : _c.data) {
                        history.push(Routes_1.Routes.PAYMENT);
                        setTransactionError(TransactionErrorTypes_1.TransactionErrorTypes.FAILED);
                    }
                    else {
                        componentHandleError(error_1);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [transactionToken]);
    react_1.useEffect(function () {
        if (transactionToken) {
            verifyAccessCode(transactionToken);
        }
    }, []);
    if (isLoading) {
        return (<core_1.Container>
        <MinimalLoader_1.default />
      </core_1.Container>);
    }
    return (<ConfirmationMainContent_1.default>
      <ReserveOnlineText_1.default />
    </ConfirmationMainContent_1.default>);
};
exports.default = errorMessageHoc_1.default(ConfirmationReserveOnlineApexx);
